import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { headingFont, truncateLine } from '@/styles/mixins';

export const DetailHeaderRoot = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[5]};

  @media (max-width: 767.98px) {
    flex-wrap: wrap;
  }
`;

export const DetailBackButton = styled(Button).attrs({
  variant: 'outline-secondary',
  size: 'sm',
  type: 'button',
})`
  flex-shrink: 0;
`;

export const DetailTitleBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DetailTitle = styled.h1`
  ${headingFont}
  ${truncateLine}
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: 0;
  letter-spacing: -0.01em;

  @media (max-width: 767.98px) {
    white-space: normal;
    word-break: break-word;
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const DetailMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
  margin-top: ${({ theme }) => theme.spacing[1]};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  flex-wrap: wrap;
`;

export const DetailActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};
  flex-shrink: 0;

  @media (max-width: 767.98px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;
